export default __webpack_public_path__ + "static/media/backgroundNew.23290cc2.svg";